import React from 'react';
import { useTranslation } from 'react-i18next';
import { couleurAvatar, T } from './utils';

/** Initiales sur fond dérivé du nom, pastille de présence optionnelle. */
export default function Avatar({ nom, initiales, taille = 36, enLigne, presence = false, style }) {
  const { t } = useTranslation('conversations');
  return (
    <span style={{ position: 'relative', display: 'inline-block', width: taille, height: taille, flexShrink: 0, ...style }}>
      <span
        aria-hidden="true"
        style={{
          width: taille, height: taille, borderRadius: '50%', display: 'flex', alignItems: 'center',
          justifyContent: 'center', background: couleurAvatar(nom || initiales || ''), color: '#fff',
          fontWeight: 600, fontSize: Math.round(taille * 0.38), letterSpacing: 0.3, userSelect: 'none',
        }}
      >
        {initiales || '?'}
      </span>
      {presence && (
        <span
          title={enLigne ? t('presence.enLigne') : t('presence.horsLigne')}
          style={{
            position: 'absolute', right: -1, bottom: -1, width: 10, height: 10, borderRadius: '50%',
            background: enLigne ? '#16a34a' : T.faible, border: `2px solid ${T.blanc}`,
          }}
        />
      )}
    </span>
  );
}
